import { LoginHelpComponent } from './login-help.component';
import { LoginComponent } from './login.component';
import { LogoutComponent } from './logout.component';
import { AccountComponent } from './account.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const accountRoutes: Routes = [
  {
    path: 'account',
    component: AccountComponent ,
    children: [
      { path: '', component: LoginComponent},
      { path: 'login', component: LoginComponent},
      { path: 'login/:code', component: LoginComponent},
      { path: 'login/:code/:code2', component: LoginComponent},
      { path: 'logout', component: LogoutComponent},

      { path: 'loginhelp', component: LoginHelpComponent },
      { path: 'forgotpassword', component: LoginHelpComponent},
      { path: 'forgotusername', component: LoginHelpComponent},

      { path: 'resetpassword/:code', component: LoginHelpComponent}, // ResetPasswordComponent // either reset password or register link sent by NWM
      { path: 'passwordreset/:type', component: LoginHelpComponent}, // ForgotPasswordComponent // equivalent of forgotpassword
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(accountRoutes)],
  exports: [RouterModule],
})
export class AccountRoutingModule { }

